/** Декоративные фигуры на холсте (рендер как type=svg). ViewBox 0 0 100 100. */

const STROKE = '#111827';

/** Толщина обводки в единицах viewBox (0–100). */
export const DEFAULT_DECORATIVE_STROKE_WIDTH = 3.5;

export function clampDecorativeStrokeWidth(w: number): number {
  if (!Number.isFinite(w)) return DEFAULT_DECORATIVE_STROKE_WIDTH;
  return Math.min(12, Math.max(1, Math.round(w * 10) / 10));
}

export type ShapeGraphicKind = 'rectangle' | 'line' | 'arrow' | 'ellipse' | 'star';

export const SHAPE_LABELS: Record<ShapeGraphicKind, string> = {
  rectangle: 'Квадрат',
  line: 'Линия',
  arrow: 'Стрелка',
  ellipse: 'Круг',
  star: 'Звезда',
};

export const SHAPE_DEFAULT_MM: Record<ShapeGraphicKind, { width: number; height: number }> = {
  rectangle: { width: 20, height: 20 },
  line: { width: 30, height: 2 },
  arrow: { width: 30, height: 12 },
  ellipse: { width: 20, height: 20 },
  star: { width: 22, height: 22 },
};

function starPath(cx: number, cy: number, outer: number, inner: number, points: number): string {
  let d = '';
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = (Math.PI / points) * i - Math.PI / 2;
    const x = cx + r * Math.cos(a);
    const y = cy + r * Math.sin(a);
    d += `${i === 0 ? 'M' : 'L'} ${x.toFixed(2)} ${y.toFixed(2)} `;
  }
  return `${d}Z`;
}

export function buildShapeSvgMarkup(
  kind: ShapeGraphicKind,
  strokeWidth: number = DEFAULT_DECORATIVE_STROKE_WIDTH,
): string {
  const sw = clampDecorativeStrokeWidth(strokeWidth);
  switch (kind) {
    case 'rectangle':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect x="5" y="5" width="90" height="90" fill="none" stroke="${STROKE}" stroke-width="${sw}" rx="8"/></svg>`;
    case 'line': {
      // На всю ширину viewBox (0–100), у нижнего края поля; butt — без вылета за края.
      const y = 100 - sw / 2;
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><line x1="0" y1="${y}" x2="100" y2="${y}" stroke="${STROKE}" stroke-width="${sw}" stroke-linecap="butt"/></svg>`;
    }
    case 'arrow':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><line x1="12" y1="50" x2="68" y2="50" stroke="${STROKE}" stroke-width="${sw}" stroke-linecap="round"/><polygon points="88,50 68,38 68,62" fill="${STROKE}"/></svg>`;
    case 'ellipse':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><ellipse cx="50" cy="50" rx="40" ry="40" fill="none" stroke="${STROKE}" stroke-width="${sw}"/></svg>`;
    case 'star':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="${starPath(50, 50, 38, 15, 5)}" fill="none" stroke="${STROKE}" stroke-width="${sw}" stroke-linejoin="round"/></svg>`;
  }
}

/** Обёртка для растрового изображения внутри SVG (data URL или https). */
export function buildImageSvgMarkup(href: string): string {
  const safe = href.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"><image xlink:href="${safe}" href="${safe}" x="0" y="0" width="100" height="100" preserveAspectRatio="xMidYMid meet"/></svg>`;
}
